<ng-select
  appendTo="body"
  [items]="items"
  [bindLabel]="bindLabel"
  [bindValue]="bindValue"
  [placeholder]="placeholder"
  [clearable]="clearable"
  (change)="selectedItem($event)"
  [searchable]="searchable"
  [readonly]="readonly"
  [(ngModel)]="value"
  (ngModelChange)="valueSelected($event)"
  (clear)="clearValue()"
  [class.disabled]="disable"
  [class.invalid]="!isValid() && control?.dirty"
  [class.required]="isRequired"
  class="rx-autocomplete-dropdown"
  [id]="id + '-autocomplete'"
>
  <ng-container *ngIf="labelTemplate">
    <ng-template id="autocomplete-label" ng-label-tmp let-item="item">
      <ng-template [ngTemplateOutlet]="labelTemplate" [ngTemplateOutletContext]="{ item: item }"> </ng-template>
    </ng-template>
  </ng-container>
  <ng-container *ngIf="optionTemplate">
    <ng-template id="autocomplete-optionl" ng-option-tmp let-item="item">
      <ng-template [ngTemplateOutlet]="optionTemplate" [ngTemplateOutletContext]="{ item: item }"> </ng-template>
    </ng-template>
  </ng-container>
</ng-select>
